import React from "react"
import { UploadDocuments } from "../DriverLicense"
import VeriffIdentityVerification from "../VeriffIdentityVerification"
import useGlobalContext from "../../../utils/customHooks/useGlobalContext"

const VERIFF = "veriff"

const IdentityVerification = ({
  mivCompleted,
  licenseValidationRequired,
  handleNext,
}) => {
  const {
    state: { currentUserMarket, tenantSettings },
  } = useGlobalContext()
  const isVeriff = currentUserMarket
    ? currentUserMarket.identity_verification_system === VERIFF
    : tenantSettings?.identityVerificationSystemString === VERIFF

  return isVeriff ? (
    <VeriffIdentityVerification handleNext={handleNext} />
  ) : (
    <UploadDocuments
      mivCompleted={mivCompleted}
      licenseValidationRequired={licenseValidationRequired}
      handleNext={handleNext}
    />
  )
}

export default IdentityVerification
